import "./Stack.scss"
export default function Stack() {
  
    return (
      <ul className="stacks">
        <li>
        FrontEnd - React.js(pwa), Scss, Material UI
        </li>
        <li>
        BackEnd - Node.js, Express
        </li>
        <li>
        Database - Postgres
        </li>
      </ul>
    );
  }